export default __webpack_public_path__ + "img/x-men-school.0928a818.svg";